import { Button, Col, Typography } from "antd";
import React from "react";
import {
  InputSelect,
  InputText,
  SimpleInputSelectMultiple,
} from "../../../../shared/components";
import { useEditComboRules, useRules3x2 } from "../../hooks";
import { SelectedDaysType } from "./Rules3x2Form";

const { Title } = Typography;

export const EditRules3x2Form = ({
  setOpenModalEditRule,
  ruleId,
}: {
  setOpenModalEditRule: (val: boolean) => void;
  ruleId: number;
}) => {
  const [selectedDays, setSelectedDays] = React.useState<string[]>([]);
  const [days, setDays] = React.useState<SelectedDaysType>({
    monday: "false",
    tuesday: "false",
    wednesday: "false",
    thursday: "false",
    friday: "false",
    saturday: "false",
    sunday: "false",
  });

  const { comboRuleById, loading } = useRules3x2({
    rule_id: ruleId,
  });

  const { editComboRule, control } = useEditComboRules({
    setOpenModalEditRule,
    comboRuleById,
    days,
  });

  const handleDaysChange = (values: string[]) => {
    setSelectedDays(values);

    const updatedDays: SelectedDaysType = {
      monday: values.includes("monday") ? "true" : "false",
      tuesday: values.includes("tuesday") ? "true" : "false",
      wednesday: values.includes("wednesday") ? "true" : "false",
      thursday: values.includes("thursday") ? "true" : "false",
      friday: values.includes("friday") ? "true" : "false",
      saturday: values.includes("saturday") ? "true" : "false",
      sunday: values.includes("sunday") ? "true" : "false",
    };
    setDays(updatedDays);
  };

  console.log(12, selectedDays);
  React.useEffect(() => {
    if (comboRuleById) {
      const activeDays = Object.keys(comboRuleById).filter(
        (day) => comboRuleById[day] === "true"
      );
      setSelectedDays(activeDays);
    }
  }, [comboRuleById]);

  console.log(122, comboRuleById);

  return (
    <form onSubmit={editComboRule}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText placeHolder="seguridad" name="name" control={control} />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Días disponibles:
        </Title>
        <SimpleInputSelectMultiple
          label="Selecciona los días"
          onChange={(e) => handleDaysChange(e)}
          valuesSelect={selectedDays}
          clearValue={(value: string) =>
            handleDaysChange(selectedDays.filter((day) => day !== value))
          }
          showSearch={true}
          dataOptions={[
            { title: "Lunes", value: "monday" },
            { title: "Martes", value: "tuesday" },
            { title: "Miércoles", value: "wednesday" },
            { title: "Jueves", value: "thursday" },
            { title: "Viernes", value: "friday" },
            { title: "Sábado", value: "saturday" },
            { title: "Domingo", value: "sunday" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        loading={loading}
      >
        Editar
      </Button>
    </form>
  );
};
